import React from 'react';
import { useTranslation } from 'react-i18next';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../../utils/SEO";

export default function HongKongCompanyForSaleWithBankAccount() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.hong-kong-company-for-sale-with-bank-account.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/hong-kong-company-for-sale-with-bank-account"
            />

            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/company-formation/hong-kong-offshore-company.png")}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('why.title')}
                        subtitle={tp('why.subtitle')}
                        blocks={[{ items: obj('why.items') }]}
                        end={tp('why.end')}
                    />

                    <LocationTimeline
                        title={tp('includes.title')}
                        subtitle={tp('includes.subtitle')}
                        item={obj('includes.item')}
                        end={tp('includes.end')}
                    />

                    <InfoBlocks
                        title={tp('structure.title')}
                        subtitle={tp('structure.subtitle')}
                        blocks={obj('structure.blocks')}
                        end={tp('structure.end')}
                    />

                    <DetailsSection
                        title={tp('nominee.title')}
                        subtitle={tp('nominee.subtitle')}
                        items={obj('nominee.items')}
                        end={tp('nominee.end')}
                    />

                    <WhySection
                        title={tp('privacy.title')}
                        subtitle={tp('privacy.subtitle')}
                        blocks={[{ items: obj('privacy.items') }]}
                        end={tp('privacy.end')}
                    />

                    <FeatureCards
                        title={tp('tax.title')}
                        subtitle={tp('tax.subtitle')}
                        features={obj('tax.features')}
                        end={tp('tax.end')}
                    />

                    <WhySection
                        title={tp('bankAccount.title')}
                        subtitle={tp('bankAccount.subtitle')}
                        blocks={[{ items: obj('bankAccount.items') }]}
                        end={tp('bankAccount.end')}
                    />

                    <FeatureCards
                        title={tp('usingBank.title')}
                        subtitle={tp('usingBank.subtitle')}
                        features={obj('usingBank.features')}
                        end={tp('usingBank.end')}
                    />

                    <WhySection
                        title={tp('nonResident.title')}
                        subtitle={tp('nonResident.subtitle')}
                        blocks={[{ items: obj('nonResident.items') }]}
                        end={tp('nonResident.end')}
                    />

                    <DetailsSection
                        title={tp('crs.title')}
                        items={obj('crs.items')}
                    />

                    <WhySection
                        title={tp('crypto.title')}
                        subtitle={tp('crypto.subtitle')}
                        blocks={[{ items: obj('crypto.items') }]}
                        end={tp('crypto.end')}
                    />

                    <InfoBlocks
                        title={tp('dueDiligence.title')}
                        subtitle={tp('dueDiligence.subtitle')}
                        blocks={obj('dueDiligence.blocks')}
                        end={tp('dueDiligence.end')}
                    />

                    <WhySection
                        title={tp('shelf.title')}
                        subtitle={tp('shelf.subtitle')}
                        blocks={[{ items: obj('shelf.items') }]}
                        end={tp('shelf.end')}
                    />

                    <TimelineSection
                        title={tp('process.title')}
                        items={obj('process.items')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')} />

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
}
